var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamClicked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_86_1677)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 44,
    height: 44,
    rx: 6,
    fill: "#513800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5893 35.3744C24.2638 35.049 24.2638 34.5213 24.5893 34.1959L35.1959 23.5893C35.5213 23.2639 36.0489 23.2639 36.3744 23.5893C36.6998 23.9147 36.6998 24.4424 36.3744 24.7678L25.7678 35.3744C25.4423 35.6998 24.9147 35.6998 24.5893 35.3744Z",
    fill: "#FAE8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5885 23.5893C24.9139 23.2638 25.4416 23.2638 25.767 23.5893L36.3736 34.1959C36.699 34.5213 36.699 35.0489 36.3736 35.3744C36.0482 35.6998 35.5205 35.6998 35.1951 35.3744L24.5885 24.7678C24.263 24.4423 24.263 23.9147 24.5885 23.5893Z",
    fill: "#FAE8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5893 34.1959C24.2638 34.5213 24.2638 35.049 24.5893 35.3744C24.9147 35.6998 25.4423 35.6998 25.7678 35.3744L36.3744 24.7678C36.6998 24.4424 36.6998 23.9147 36.3744 23.5893C36.0489 23.2639 35.5213 23.2639 35.1959 23.5893L24.5893 34.1959Z",
    fill: "#FAE8C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_86_1677",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.698039 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_1677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_1677",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.419608 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_86_1677"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamClicked);
export default __webpack_public_path__ + "static/media/hamClicked.85cabd465baaee19409c4882fad65aa6.svg";
export { ForwardRef as ReactComponent };